import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IUser } from 'src/shared/interfaces/user.interface';
import { FavieAuthService } from '../auth/favie-auth.service';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private readonly END_POINT = `${environment.apiUrl}/v1/users`;
  constructor(
    private readonly http: HttpClient,
    private readonly favieAuthService: FavieAuthService
  ) {}

  public getProfile() {
    return this.http.get<IUser>(`${this.END_POINT}/me`).pipe(
      map((user) => {
        this.favieAuthService.setUserProfile(user);
        return user;
      })
    );
  }

  public setEmailVerified(email: string) {
    return this.http.post(`${this.END_POINT}/email_verified`, {email});
  }

  public delete() {
    return this.http.delete(`${this.END_POINT}`);
  }
}
